import { useEffect, useState } from 'react';
import { z } from 'zod';
import styled, { css } from 'styled-components';
import {
  ButtonContainer,
  InputWrapper,
  Loading,
  PrimaryButton,
  SecondaryButton,
  SectionHeading,
  SecondaryAltButton,
  SectionWrapper
} from '../../atoms';
import { zodResolver } from '@hookform/resolvers/zod';
import { type SubmitHandler, useForm } from 'react-hook-form';
import { Request } from '../../../apis';
import { toast } from 'react-hot-toast';

type TEditUserMobile = {
  mobile: string;
  isModalOpen: boolean;
  apiEndpoint: string | null;
  refresh: {
    shouldRefresh: boolean;
    setShouldRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  };
};

type TEditUserMobileRequest = {
  mobile: string;
};

const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Heading = styled((props) => <SectionHeading {...props} />)`
  margin-top: 20px !important;
  margin-bottom: 20px;
`;

const EditWrapper = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.paddings.sm};
    padding-bottom: ${theme.paddings.sm};
  `
);

const FormFooter = styled((props) => <ButtonContainer {...props} />)`
  margin-top: 5px;
  margin-bottom: 20px;
`;

const ErrorStyles = styled.div(
  ({ theme }) => css`
    text-align: right;
    color: ${theme.colors.main.error};
    margin-bottom: 15px;
  `
);

const editMobileFormSchema = z.object({
  mobile: z
    .string()
    .regex(/^(\+61\d{9}|04\d{8})$/, 'Please enter a valid mobile.')
});

type EditMobileFormSchema = z.infer<typeof editMobileFormSchema>;

const EditUserMobile = ({
  mobile,
  apiEndpoint,
  isModalOpen,
  refresh
}: TEditUserMobile) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<EditMobileFormSchema>({
    resolver: zodResolver(editMobileFormSchema),
    defaultValues: {
      mobile: mobile
    }
  });

  const [errorMessage, setErrorMessage] = useState('');
  const [editing, setEditing] = useState<boolean>(false);
  const [processing, setProcessing] = useState<boolean>(false);
  const [mobileState, setMobileState] = useState(mobile);

  const handleReset = () => {
    setEditing(false);
    setProcessing(false);
    setErrorMessage('');
    // reset form
    reset({ mobile: mobileState });
  };

  // Commented out till endpoint updates cognito data too
  // useEffect(() => {
  //   if (isModalOpen === false && editing === true) {
  //     handleReset();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isModalOpen]);

  // const onSubmit: SubmitHandler<EditMobileFormSchema> = async (data: any) => {
  //   setErrorMessage('');
  //   if (!apiEndpoint) {
  //     setErrorMessage('Something unexpected occurred.');
  //     return;
  //   }
  //   if (mobileState === data.mobile) {
  //     setErrorMessage('No changes made');
  //     return;
  //   }
  //   try {
  //     const { mobile } = data;
  //     const editUserRequest: Partial<TEditUserMobileRequest> = {
  //       mobile
  //     };

  //     setProcessing(true);
  //     await Request.patch(`${apiEndpoint}`, z.any(), editUserRequest);
  //     setMobileState(mobile);
  //     setProcessing(false);
  //     setEditing(false);
  //     toast.success('User edited.');
  //     if (refresh.shouldRefresh === false) {
  //       refresh.setShouldRefresh(true);
  //     }
  //   } catch (err: any) {
  //     //setErrorMessage(err.message); -- replaced with generic error
  //     setErrorMessage('Something unexpected occurred.');
  //     setProcessing(false);
  //   }
  // };

  return (
    <>
      {/* <form onSubmit={handleSubmit(onSubmit)} noValidate={true}> */}
      <SectionWrapper>
        <HeadingWrapper>
          <Heading>Mobile</Heading>
          {/* Commented out till endpoint updates cognito data too */}
          {/* {!editing && (
            <EditWrapper>
              <SecondaryAltButton
                type="button"
                onClick={(e) => {
                  setEditing(true);
                }}
              >
                Edit Mobile{' '}
                <span className="material-symbols-rounded">edit</span>
              </SecondaryAltButton>
            </EditWrapper>
          )} */}
        </HeadingWrapper>

        <InputWrapper
          name="mobile"
          type="text"
          disabled={!editing}
          register={register}
          defaultValue={mobileState}
          errorMessage={errors.mobile?.message}
        />
        <ErrorStyles>{errorMessage}</ErrorStyles>
      </SectionWrapper>
      {/* Commented out till endpoint updates cognito data too */}
      {/*{editing && (
       <FormFooter
         horizontalSpacing="10px"
         verticalSpacing="0px"
         justify="end"
       >
         {processing ? (
           <Loading />
         ) : (
           <>
             <SecondaryButton
               type="button"
               onClick={(e) => {
                 handleReset();
               }}
             >
               Cancel
             </SecondaryButton>
             <PrimaryButton type="submit">Save Mobile</PrimaryButton>
           </>
         )}
       </FormFooter>
     )}
   </form> */}
    </>
  );
};

export { EditUserMobile };
